define([
    "language/resource"
], function (i18n) {
    "use strict";

    var ctrl = function ($scope, $compile) {
        document.title = i18n("titles.welcomeEmail");
        $scope.i18n = i18n;
        $scope.model = {
        };
        $("#failedContainer").css({"background-color":"#F4F4F4", "margin-top": "100px"});
        $("#failedContent").css("background-color","#F4F4F4");
    };

    ctrl = ["$scope", "$compile", ctrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller("authui.welEmailFailed.ctrl", ctrl);

    return ctrl;
});



// WEBPACK FOOTER //
// ./public/hws/js/welcomeemail/controllers/failedController.js